export type AckodriveTokensCookie = {
  access?: string;
  refresh?: string;
};

export const parseAckodriveTokensCookie = (
  rawTokenCookie?: string | null
): AckodriveTokensCookie | null => {
  if (!rawTokenCookie) {
    return null;
  }

  const tokenCandidates = [String(rawTokenCookie)];

  try {
    const decodedCookie = decodeURIComponent(String(rawTokenCookie));
    if (decodedCookie !== rawTokenCookie) {
      tokenCandidates.unshift(decodedCookie);
    }
  } catch {
    // Ignore malformed URI sequences and fall back to the raw cookie value.
  }

  for (const tokenCandidate of tokenCandidates) {
    try {
      const parsedCookie = JSON.parse(tokenCandidate) as AckodriveTokensCookie;
      if (parsedCookie && typeof parsedCookie === "object") {
        return parsedCookie;
      }
    } catch {
      // Try the next candidate.
    }
  }

  return null;
};

export const getAckodriveAccessToken = (
  rawTokenCookie?: string | null
): string | undefined => {
  return parseAckodriveTokensCookie(rawTokenCookie)?.access || undefined;
};
